// extracted by mini-css-extract-plugin
module.exports = {"arrows":"arrows_arrows__8_Z0u","hide":"arrows_hide__vagEE"};